import {invariant} from '~/library/toolbox';
import {selectTopupFiatOperations, uniqueById} from "../SelectorTools";
import {FinancialData} from '~/redux/finances';
import {TopupPageProps, TopupParams} from '../../ui/Topup/TopupPage';

export function selectTopupData(params: TopupParams) {
    const {accountId, methodType, methodId} = params;
    return function (finData: FinancialData): TopupPageProps | null {
        const currentAccount = finData.accounts.find(acc => acc.id === accountId);
        if (!currentAccount) return null;

        const provider = finData.providers.find(p => p.id === currentAccount.providerId);
        invariant(!!provider, `Provider with id ${currentAccount.providerId} not found`);

        const providerName = provider.name;

        const topupOperations = selectTopupFiatOperations(finData);
        const operationsForAccount = topupOperations.filter(op => op.account.id === currentAccount.id);

        const accounts = uniqueById(
            topupOperations.filter(op => op.account.providerId === provider.id).map(op => op.account)
        );

        const methods = uniqueById(
            operationsForAccount.filter(op => op.account.id === currentAccount.id).map(op => op.target)
        );
        const method = methods.find(m => m.type === methodType && m.id === methodId);

        return {
            providerName,
            accounts,
            methods,
            account: currentAccount,
            method,
            operations: topupOperations,
            ...params,
        };
    };
}
